export default [
	{"text": "< 30min",     "identifier": "30"},
	{"text": "30min - 1h",  "identifier": "60"},
	{"text": "1h - 2h",     "identifier": "120"},
	{"text": "+2h",         "identifier": "-1"}
];
